import React, { Component } from 'react'
import PropTypes from 'prop-types'
import {
    Button,
    Alert
} from 'reactstrap'

import CleaningHistoryList from './CleaningHistoryList'

import api from '../api'
import NotificationService from '../../../services/NotificationService.js'

class CleaningHistory extends Component {

    static propTypes = {
        startdate: PropTypes.oneOfType([ PropTypes.number, PropTypes.string ]),
        enddate: PropTypes.oneOfType([ PropTypes.number, PropTypes.string ])
    }

    state = {
        cleaningHistory: [],
        requested: false,
        success: false,
        error: null
    }

    handleClick = async() => {
        const { startdate, enddate } = this.props

        try {
            const response = await api.getCleaningHistory(startdate, enddate)
            if (response && response.body) {
                this.setState({
                    cleaningHistory: response.body.value,
                    requested: true,
                    success: true
                })
            } else {
                this.setState({
                    requested: true,
                    success: false
                })
            }
        } catch (err) {
            this.setState({
                requested: false
            }, () =>
                NotificationService.notifyError({
                    title: err.message || 'Fout',
                    message: 'Er is een fout opgetreden tijdens het verwerken van het verzoek.'
                })
            )
        } finally {
            window.setTimeout(() => {
                this.setState({
                    requested: false,
                    success: false
                })
            }, 10000) // reset after 10 seconds
        }
    }

    render() {
        const isValid = new Date(this.props.startdate) <= new Date(this.props.enddate)

        let color = this.state.requested ?
            this.state.success ? 'success' : 'danger'
            : 'light'

        if (this.state.error) {
            color = 'danger'
        }

        return (
            <div>
                <Button
                    disabled={ !isValid }
                    onClick={ this.handleClick }
                    color={ color }
                >
                Toon schonen historie
                </Button>
                <CleaningHistoryList data={ this.state.cleaningHistory } />
                { this.state.error && (
                    <div className="mt-1">
                        <Alert color="danger">{ this.state.error }</Alert>
                    </div>
                ) }
            </div>
        )
    }
}

export default CleaningHistory
